import React, { useEffect, useState } from "react";
import {
  NotMessage,
  ProjectDetailSection,
  ProjectSchedulerContainer,
} from "../../common/styled/project";
import { showEventTime } from "../../../../scheduler/component/function/common";
import { useLocation, useNavigate, useParams } from "react-router";
import { IoAddSharp } from "react-icons/io5";
import { useSelector } from "react-redux";
import moment from "moment";
import axios from "axios";

const Scheduler = ({ project, participantList, schedule }) => {
  const navigate = useNavigate();
  const { projectNo } = useParams();
  const { pathname } = useLocation();

  const user = useSelector((state) => state?.user?.data[0]);
  const company = useSelector((state) => state?.company?.data);

  const mber = participantList.find((participant) => participant.mberNo === user.mberNo);

  const [participant, setParticipant] = useState(null);

  // 일정 조회
  // const getProjectSchedule = async () => {
  //   const url = "/api/scheduleList";
  //   const body = {
  //     projectNo: project.projectNo,
  //     mberNo: user.mberNo,
  //   };

  //   if (project.gbn === "C") {
  //     if (mber) {
  //       body.cmpnyNos = [mber.orgNo];
  //     } else {
  //       const target = participantList.find((member) =>
  //         company.some((cmp) => cmp.cmpnyNo === member.orgNo),
  //       );

  //       if (target) {
  //         body.cmpnyNos = [target.orgNo];
  //       }
  //     }
  //   } else {
  //     body.groupNos = [project.orgNo];
  //   }

  //   const res = await axios.post(url, body);

  //   if (res.status === 200) {
  //     setSchedule(res.data);
  //   }
  // };

  useEffect(() => {
    // getProjectSchedule();
    setParticipant(participantList.filter((item) => user.mberNo === item.mberNo)?.[0]);
  }, []);

  return (
    <ProjectDetailSection>
      <ProjectSchedulerContainer>
        {schedule.length > 0 ? (
          <ul>
            {schedule.map((item) => (
              <li
                onClick={() =>
                  navigate(`/mypage/detailEvent/${item.scheduleNo}`, {
                    state: {
                      path: `/mypage/project/${projectNo}`,
                      tab: 2,
                    },
                  })
                }>
                <span className="tit">{item.title}</span>
                <span>{showEventTime(item.startDt, item.endDt)}</span>
              </li>
            ))}
          </ul>
        ) : (
          <NotMessage>해당 프로젝트의 일정이 존재하지 않습니다.</NotMessage>
        )}
        {participant && (
          <button
            className="addScheduler"
            onClick={() =>
              navigate(`/mypage/scheduler/form`, {
                state: {
                  path: pathname,
                  eventInfo: {
                    startDt: moment().format("YYYY-MM-DD HH:30:00"),
                    endDt: moment().startOf("hour").add(1, "hour").format("YYYY-MM-DD HH:30:00"),
                    projectNo,
                    projectNm: project.projectNm,
                    gbn: project.gbn,
                    orgNo: project.gbn === "C" ? participant.orgNo : project.orgNo,
                  },
                },
              })
            }>
            <IoAddSharp />
          </button>
        )}
      </ProjectSchedulerContainer>
    </ProjectDetailSection>
  );
};

export default Scheduler;
